import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { setCheckoutWidgetOnKioskFlag } from 'state/checkout-widget-on-kiosk-flag';

export default function useCheckoutWidgetOnKioskFlagController(): void {
  const flags = useFlags();
  const rawFlagValue = flags['pos.ecomm.checkout-widget-on-kiosk.rollout'];

  useEffect(() => {
    setCheckoutWidgetOnKioskFlag(!!rawFlagValue);
  }, [rawFlagValue]);
}
